$(document).ready(function () {
    // Form validate on forgot password
    FormValidateForgotPassword($('form#frmForgotPassword'));
});
